var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_1497)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83768 0.745605C1.34498 0.745605 0.945558 1.14502 0.945558 1.63773C0.945558 2.13045 1.34498 2.52987 1.83768 2.52987H2.72876V18.5883L1.83744 18.5883C1.34473 18.5883 0.945312 18.9879 0.945312 19.4806C0.945312 19.9733 1.34473 20.3726 1.83744 20.3726H19.6801C20.1728 20.3726 20.5722 19.9733 20.5722 19.4806C20.5722 18.9879 20.1728 18.5883 19.6801 18.5883H18.7872V2.52987H19.6804C20.173 2.52987 20.5725 2.13045 20.5725 1.63773C20.5725 1.14502 20.173 0.745605 19.6804 0.745605H17.0029H4.51303H1.83768ZM6.74389 4.31439H7.63603V6.09866H6.74389V4.31439ZM10.3125 4.31439H11.2045V6.09866H10.3125V4.31439ZM13.881 4.31439H14.773V6.09866H13.881V4.31439ZM6.74389 6.99079H7.63603V8.77505H6.74389V6.99079ZM10.3125 6.99079H11.2045V8.77505H10.3125V6.99079ZM12.9888 7.88293C12.9888 7.39022 13.3883 6.99079 13.881 6.99079H14.773C15.2658 6.99079 15.6653 7.39022 15.6653 7.88293C15.6653 8.37565 15.2658 8.77505 14.773 8.77505H13.881C13.3883 8.77505 12.9888 8.37565 12.9888 7.88293ZM8.73254 11.3259C8.17318 11.3259 7.71973 11.7794 7.71973 12.3388L7.71975 20.3706H8.73254H9.74538V13.3516H11.7711V20.3706H12.7838H13.7966V12.3388C13.7966 11.7794 13.3432 11.3259 12.7838 11.3259H8.73254Z",
    fill: "#E10F3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_1497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.305ae5cc12adc028a141d10589c9a80b.svg";
export { ForwardRef as ReactComponent };